import React from "react"
// Components
import { StaticQuery,graphql } from 'gatsby';
import Layout from "../components/layout"
import { Seo } from "../components/Seo"
import { Container1200 } from '../components/Container1200';
import { PageTitle } from '../components/PageTitle';
import { ShowcaseItem } from '../components/ShowcaseItem';
import { TitleWithLine } from '../components/TitleWithLine';
// Style
import {
  Blurb,
  BlurbBox,
  Designs,
  DesignBoxes,
  Intro
} from '../styles/pages-styles/design.styles';

const Design = () => {
  const query = graphql`
    query DesignItemsQuery {
      allDesignJson {
        edges {
          node {
            id
            image {
              childImageSharp {
                fluid(maxWidth: 384
                  quality: 100
                  traceSVG: { color: "#BDBDBD" }
                ) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
            linkType
            target
            title
            url
          }
        }
      }
    }
  `;

  return (
    <Layout>
      <Seo title="Digital Design | DaveJudd.com" />
      <Intro id="intro">
        <Container1200>
          <PageTitle>Digital Design</PageTitle>
          <BlurbBox>
            <Blurb>Check out some of my recent designs.</Blurb>
          </BlurbBox>
        </Container1200>
      </Intro>
      <Designs id="designs">
        <Container1200>
          <TitleWithLine>Recent Designs</TitleWithLine>
          <DesignBoxes>
            <StaticQuery
              query={query}
              render={data => (
                  <>
                    {data.allDesignJson.edges.map(({ node }) => (
                        <ShowcaseItem
                          key={node.id}
                          image={node.image.childImageSharp.fluid}
                          linkType={node.linkType}  
                          target={node.target}
                          to={node.url}
                        >
                          <h2>{node.title}{node.linkType === 'external' && <i className="fas fa-external-link-alt"></i>}</h2>
                        </ShowcaseItem>
                      )
                    )}
                  </>
              )}
            >
            </StaticQuery>
          </DesignBoxes>
        </Container1200>
      </Designs>
    </Layout>
  )
}

export default Design;
